import axios from 'axios'

const authorizeAbsenceRequest =  async function(id){
    try{
        const   path = `/hr_absence_request/${id}/authorize`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            ,   response = await axios.post(route)
        return response.data
    }
    catch( error ) {
        return error.response.data
    }
}

export { authorizeAbsenceRequest }
